import DateTimePicker from '@/components/Form/DateTimePicker'
import FormLabel from '@/components/Form/FormLabel'
import ClockIcons from '@/icons/ClockIcons'
import React from 'react'
import { Control } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { Typogaphy } from 'vnetwork-ui'
import helpContent from '@/modules/Ticket/help/ticket-estimated-completion-help.md'

interface Props {
    control: Control<any>
    disabled?: boolean
    slaTime?: string | number
    slaTimeFormat?: string // 'minute' | 'hour' | 'day'
    slaSource?: 'ticket_type' | 'service_sla' // Source of SLA
}

const TicketEstimatedCompletion: React.FC<Props> = ({
    control,
    disabled = false,
    slaTime,
    slaTimeFormat,
    slaSource,
}) => {
    const { t } = useTranslation()

    const hasSLA = !!slaTime && !!slaTimeFormat

    const formatSLATimeLabel = () => {
        if (!slaTime || !slaTimeFormat) return ''
        const timeValue = Number(slaTime)
        switch (slaTimeFormat) {
            case 'minute':
                return t('sla-minutes', { count: timeValue })
            case 'hour':
                return t('sla-hours', { count: timeValue })
            case 'day':
                return t('sla-days', { count: timeValue })
            default:
                return `${timeValue} ${slaTimeFormat}`
        }
    }

    const getSLASourceLabel = () => {
        switch (slaSource) {
            case 'service_sla':
                return t('sla-from-service', 'từ SLA dịch vụ')
            case 'ticket_type':
                return t('sla-from-ticket-type', 'từ loại ticket')
            default:
                return ''
        }
    }

    return (
        <div>
            <FormLabel
                label={t('ticket-estimated-completion-date-lable')}
                helpContent={helpContent}
                helpTitle={t('ticket-estimated-completion-help')}
            />
            <DateTimePicker
                control={control}
                name="ticket_estimated_completion_date"
                disabled={disabled}
            />
            {hasSLA && (
                <div className="flex items-center gap-1.5 mt-1.5">
                    <ClockIcons className="w-3.5 h-3.5 text-green-600" />
                    <Typogaphy
                        size="small"
                        className="text-green-700 text-xs italic font-medium"
                    >
                        {t('sla-applied')}: {formatSLATimeLabel()}
                        {slaSource && (
                            <span className="text-blue-600 ml-1">
                                ({getSLASourceLabel()})
                            </span>
                        )}
                    </Typogaphy>
                </div>
            )}
        </div>
    )
}

export default TicketEstimatedCompletion
